import { useEffect, useState, useCallback } from "react";
import { ChatCrypto } from "../utils/crypto";
import { uploadKeyBundle, getMyKeyBundle } from "../api/chatService";
import useChatStore from "../store/chatStore";

export function useChatCrypto() {
  const [initialized, setInitialized] = useState(false);
  const currentUserId = useChatStore((s) => s.currentUserId);

  const initializeKeys = useCallback(async () => {
    if (!currentUserId) return;

    try {
      // 1. Get or generate local identity keypair
      const keyPair = await ChatCrypto.getIdentityKeyPair();
      const pubKeyBase64 = await ChatCrypto.exportPublicKey(keyPair.publicKey);

      // 2. Check if server has our public key
      try {
        const { data: bundle } = await getMyKeyBundle();
        if (bundle && bundle.identity_public_key === pubKeyBase64) {
          console.log("[Crypto] Public key matches server.");
          setInitialized(true);
          return;
        }
      } catch (err) {
        // 404 or other error means we need to upload
      }

      // 3. Upload public key (Key Bundle)
      console.log("[Crypto] Uploading new public key bundle...");
      await uploadKeyBundle({
        identity_public_key: pubKeyBase64,
        // Optional: sign with a signing key if implementing authenticity
        signing_public_key: pubKeyBase64, 
      });

      setInitialized(true);
    } catch (err) {
      console.error("[Crypto] Initialization failed:", err);
    }
  }, [currentUserId]);

  useEffect(() => {
    if (currentUserId && !initialized) {
      initializeKeys();
    }
  }, [currentUserId, initialized, initializeKeys]);

  return { initialized };
}
